import constantCreator from 'utils/constantCreator';
import api from 'utils/api';

const define = constantCreator('section');
const SEARCH = define('SEARCH', true);
const GET_SECTION = define('GET_SECTION', true);
const CREATE_SECTION = define('CREATE_SECTION', true);
const EDIT_SECTION = define('EDIT_SECTION', true);

const initialState = {
  searching: false,
  sections: [],
  isLoading: true,
  section: {}
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SEARCH.PENDING:
      return {
        ...state,
        searching: true,
        sections: []
      };
    case SEARCH.RESOLVED:
      return {
        ...state,
        searching: false,
        sections: action.data ? action.data.topic : []
      };
    case SEARCH.REJECTED:
      return {
        ...state,
        searching: false,
      };
    case GET_SECTION.PENDING:
      return {
        ...state,
        isLoading: true,
        section: {}
      };
    case GET_SECTION.RESOLVED:
      return {
        ...state,
        isLoading: false,
        section: action.data
      };
    case GET_SECTION.REJECTED:
      return {
        ...state,
        isLoading: false
      };
    default: return state;
  }
};

export const actions = {
  searchSection: (text) => ({
    type: SEARCH,
    promise: api.post('/elasticsearch/search', {
      text,
      keys: { topic: { skip: 0, limit: 0 } }
    }),
    success: 'Search section done',
    error: 'Search section fail',
  }),
  getSection: id => ({
    type: GET_SECTION,
    promise: api.get(`/topics/${id}`),
    error: 'Unable to load section data'
  }),
  createSection: data => ({
    type: CREATE_SECTION,
    promise: api.post('/topics', data),
    success: 'Section has been created',
    error: 'Unable to create new section'
  }),
  editSection: (id, data) => ({
    type: EDIT_SECTION,
    promise: api.put(`/topics/${id}`, data),
    success: 'Section has been edited',
    error: 'Unable to edited section'
  }),
};



// WEBPACK FOOTER //
// ./src/ducks/section.js